// Právní dokumenty (vzorové znění pro M + J s.r.o.). Doporučujeme kontrolu právníkem.

export const COMPANY = {
  name: "M + J s.r.o.",
  ic: "27069354",
  dic: "CZ27069354",
  address: "Truhlářská 893, 251 68 Kamenice – Těptín",
  email: "alukola-bazar@seznam.cz",
  phone: "+420 777 181 818",
  web: "alukola-bazar.cz",
  founded: "2003",
};

const provozovatel = {
  h: "Provozovatel (správce)",
  p: [
    `${COMPANY.name}, IČ: ${COMPANY.ic}, DIČ: ${COMPANY.dic}`,
    `Sídlo: ${COMPANY.address}`,
    `E-mail: ${COMPANY.email} · Telefon: ${COMPANY.phone}`,
    `Web: ${COMPANY.web}`,
    "Společnost zapsaná v obchodním rejstříku.",
  ],
};

const LEGAL = {
  privacy: {
    title: "Zásady ochrany osobních údajů (GDPR)",
    updated: "Červen 2026",
    sections: [
      provozovatel,
      {
        h: "1. Jaké údaje zpracováváme",
        p: [
          "Při odeslání poptávky přes kontaktní formulář zpracováváme údaje, které nám sami sdělíte:",
        ],
        li: [
          "jméno a příjmení",
          "e-mailová adresa",
          "telefonní číslo (nepovinné)",
          "obsah zprávy / poptávky",
        ],
      },
      {
        h: "2. Účel a právní základ zpracování",
        p: [
          "Vaše údaje zpracováváme za účelem vyřízení poptávky, komunikace se zájemcem a případného uzavření a plnění smlouvy.",
          "Právním základem je plnění smlouvy, resp. provedení opatření před uzavřením smlouvy (čl. 6 odst. 1 písm. b GDPR) a náš oprávněný zájem na vyřízení dotazu (čl. 6 odst. 1 písm. f GDPR).",
        ],
      },
      {
        h: "3. Doba uchování",
        p: [
          "Údaje z poptávek uchováváme po dobu nezbytnou k vyřízení a následně po dobu vyžadovanou právními předpisy. Poté jsou vymazány.",
        ],
      },
      {
        h: "4. Příjemci a zpracovatelé",
        p: [
          "Osobní údaje nepředáváme třetím stranám za účelem marketingu. Ke zpracování mohou mít technický přístup naši zpracovatelé zajišťující provoz webu (hosting) a e-mailové služby, a to na základě zpracovatelské smlouvy.",
        ],
      },
      {
        h: "5. Vaše práva",
        p: ["V souladu s GDPR máte právo:"],
        li: [
          "na přístup ke svým osobním údajům",
          "na opravu nepřesných údajů",
          "na výmaz („právo být zapomenut“)",
          "na omezení zpracování",
          "vznést námitku proti zpracování",
          "na přenositelnost údajů",
          "podat stížnost u Úřadu pro ochranu osobních údajů (www.uoou.cz)",
        ],
      },
      {
        h: "6. Cookies",
        p: [
          "Informace o používání souborů cookies naleznete v samostatném dokumentu „Zásady používání cookies“.",
        ],
      },
      {
        h: "7. Kontakt",
        p: [
          `S dotazy k ochraně osobních údajů se obraťte na: ${COMPANY.email}, tel. ${COMPANY.phone}.`,
        ],
      },
    ],
  },

  cookies: {
    title: "Zásady používání cookies",
    updated: "Červen 2026",
    sections: [
      provozovatel,
      {
        h: "Co jsou cookies",
        p: [
          "Cookies jsou malé textové soubory ukládané ve vašem prohlížeči, které pomáhají zajistit správné fungování webu a analyzovat jeho užívání.",
        ],
      },
      {
        h: "Jaké kategorie cookies používáme",
        li: [
          "Nezbytné (technické) – potřebné pro základní chod webu (např. uložení vaší volby souhlasu s cookies). Nelze je vypnout.",
          "Analytické – pomáhají nám měřit návštěvnost a zlepšovat web. Načítají se pouze s vaším souhlasem.",
          "Marketingové – slouží k cílení reklamy. Načítají se pouze s vaším souhlasem.",
        ],
      },
      {
        h: "Souhlas a jeho odvolání",
        p: [
          "Při první návštěvě vám zobrazíme cookie lištu, kde můžete souhlas udělit (Přijmout vše), odmítnout (Odmítnout vše) nebo si vybrat jednotlivé kategorie (Upravit nastavení).",
          "Své nastavení můžete kdykoli změnit kliknutím na odkaz „Nastavení cookies“ v patičce webu.",
          "Analytické ani marketingové cookies se bez vašeho souhlasu nenačítají.",
        ],
      },
    ],
  },

  terms: {
    title: "Obchodní podmínky",
    updated: "Červen 2026",
    sections: [
      provozovatel,
      {
        h: "1. Úvodní ustanovení",
        p: [
          "Tyto obchodní podmínky upravují vztahy mezi provozovatelem jako prodávajícím a kupujícím. Web slouží k prezentaci nabídky alu kol, pneumatik, pokliček a autodílů.",
        ],
      },
      {
        h: "2. Objednávka a uzavření smlouvy",
        p: [
          "Zboží je možné poptat prostřednictvím kontaktního / poptávkového formuláře, telefonicky nebo e-mailem. Kupní smlouva vzniká potvrzením objednávky ze strany prodávajícího.",
          "Prezentace zboží na webu má informativní charakter a není závaznou nabídkou k uzavření smlouvy.",
        ],
      },
      {
        h: "3. Ceny a platba",
        p: [
          "Ceny uvedené u zboží jsou v korunách českých. Konkrétní podmínky platby jsou domluveny individuálně (hotově při převzetí, případně převodem).",
        ],
      },
      {
        h: "4. Dodání zboží",
        p: [
          "Zboží lze převzít osobně po domluvě. Pro Prahu nabízíme rozvoz zboží. Termín a způsob dodání jsou domluveny individuálně.",
        ],
      },
      {
        h: "5. Odpovědnost za vady, záruka",
        p: [
          "Práva a povinnosti z vadného plnění se řídí příslušnými ustanoveními občanského zákoníku. Podrobnosti upravuje Reklamační řád.",
        ],
      },
      {
        h: "6. Odstoupení od smlouvy",
        p: [
          "Je-li smlouva uzavřena distančním způsobem, má spotřebitel právo odstoupit od smlouvy dle samostatného dokumentu „Odstoupení od smlouvy“.",
        ],
      },
      {
        h: "7. Mimosoudní řešení sporů",
        p: [
          "K mimosoudnímu řešení spotřebitelských sporů je příslušná Česká obchodní inspekce (www.coi.cz).",
        ],
      },
      {
        h: "8. Závěrečná ustanovení",
        p: [
          "Tyto podmínky nabývají účinnosti dnem zveřejnění. Provozovatel si vyhrazuje právo je změnit.",
        ],
      },
    ],
  },

  reklamace: {
    title: "Reklamační řád",
    updated: "Červen 2026",
    sections: [
      provozovatel,
      {
        h: "1. Rozsah",
        p: [
          "Reklamační řád upravuje způsob a podmínky uplatnění práv z vadného plnění (reklamace) u zboží zakoupeného od provozovatele.",
        ],
      },
      {
        h: "2. Lhůty pro uplatnění práv z vad",
        p: [
          "U nového zboží může spotřebitel uplatnit právo z vady ve lhůtě 24 měsíců od převzetí. U použitého zboží může být tato doba zkrácena na 12 měsíců, na což bude kupující upozorněn.",
        ],
      },
      {
        h: "3. Uplatnění reklamace",
        p: [
          `Reklamaci uplatněte u provozovatele – kontaktujte nás na ${COMPANY.email} nebo tel. ${COMPANY.phone}. Uveďte popis vady a doložte doklad o koupi.`,
        ],
      },
      {
        h: "4. Vyřízení reklamace",
        p: [
          "Reklamace bude vyřízena bez zbytečného odkladu, nejpozději do 30 dnů ode dne jejího uplatnění, nedohodneme-li se jinak. O vyřízení vás budeme informovat.",
        ],
      },
      {
        h: "5. Mimosoudní řešení sporů",
        p: [
          "V případě, že dojde ke sporu, je k mimosoudnímu řešení příslušná Česká obchodní inspekce (www.coi.cz).",
        ],
      },
    ],
  },

  odstoupeni: {
    title: "Odstoupení od smlouvy",
    updated: "Červen 2026",
    sections: [
      provozovatel,
      {
        h: "1. Právo odstoupit od smlouvy",
        p: [
          "Byla-li smlouva uzavřena distančním způsobem (na dálku – např. e-mailem či telefonicky bez osobní prohlídky), má spotřebitel právo odstoupit od smlouvy bez udání důvodu ve lhůtě 14 dnů ode dne převzetí zboží.",
          "Toto právo se neuplatní u zboží zakoupeného osobně na prodejně po předchozí prohlídce.",
        ],
      },
      {
        h: "2. Jak odstoupit",
        p: [
          `Odstoupení zašlete na e-mail ${COMPANY.email} nebo písemně na adresu sídla. Můžete využít níže uvedený vzorový formulář.`,
        ],
      },
      {
        h: "3. Důsledky odstoupení",
        p: [
          "Peněžní prostředky vrátíme nejpozději do 14 dnů od odstoupení, nejdříve však po obdržení vráceného zboží. Náklady na vrácení zboží nese kupující.",
          "Zboží musí být vráceno nepoškozené a kompletní.",
        ],
      },
      {
        h: "Vzorový formulář pro odstoupení od smlouvy",
        p: [
          `Adresát: ${COMPANY.name}, ${COMPANY.address}, ${COMPANY.email}`,
          "Oznamuji, že tímto odstupuji od smlouvy o nákupu tohoto zboží: …",
          "Datum objednání / převzetí: …",
          "Jméno a příjmení spotřebitele: …",
          "Adresa spotřebitele: …",
          "Datum a podpis: …",
        ],
      },
    ],
  },
};

export default LEGAL;
